module.exports = __webpack_public_path__ + "01f0f49c0a68c891e3535217da952c20.jpg";